import React from 'react';

import asyncRoute from '../../../helpers/hoc/asyncRoute';
import merohaAppIcon from '../../../assets/images/meroha-app-icon-transition.png';
import qwikyAppIcon from '../../../assets/images/qwiky-app-icon.png';

import './RebrandAnnouncement.scss';

const Popup = asyncRoute(() => import('../../../components/Popup'));

const RebrandAnnouncement = ({ open, onClose }) => (
  <Popup
    className="rebrand-announcement"
    openSegmentPopup={open}
    dismissSegmentPopup={onClose}
    handleCTA={onClose}
    content={{
      title: 'Qwiky is now Meroha',
      popupCTA: 'EXPLORE MEROHA',
    }}
    themeContext="booking"
  >
    <div className="rebrand-announcement_content">
      <div className="rebrand-announcement_brand-story" aria-label="Qwiky is now Meroha">
        <div className="rebrand-announcement_app-identity rebrand-announcement_app-identity--qwiky">
          <div className="rebrand-announcement_icon-frame">
            <img src={qwikyAppIcon} alt="Qwiky app icon" />
          </div>
          <span>Qwiky</span>
        </div>
        <div className="rebrand-announcement_transition" aria-hidden="true">
          <span className="rebrand-announcement_transition-line" />
          <span className="rebrand-announcement_transition-heart">♥</span>
          <span className="rebrand-announcement_transition-arrow">›</span>
        </div>
        <div className="rebrand-announcement_app-identity rebrand-announcement_app-identity--meroha">
          <div className="rebrand-announcement_icon-frame">
            <img src={merohaAppIcon} alt="Meroha app icon" />
          </div>
          <span>Meroha</span>
        </div>
      </div>
      <p className="rebrand-announcement_lead">
        A new name and a bigger purpose, with the trusted service you already know.
      </p>
      <div className="rebrand-announcement_house-help">
        <span className="rebrand-announcement_house-icon" aria-hidden="true">
          ♡
        </span>
        <div>
          <strong>House Help continues as usual</strong>
          <span>You can keep booking the same services from their new home inside Meroha.</span>
        </div>
      </div>
      <p className="rebrand-announcement_more">
        Over time, Meroha will bring together more ways to help—including companionship and
        medical-support services.
      </p>
    </div>
  </Popup>
);

export default RebrandAnnouncement;
